const mutations = {
  SET_PRODUCTS (state, { products }) {
    state.products = products
  }
}

export default mutations
